import { ReactElement, useContext, useState } from "react"
import { AuthContext, Rotina } from "../../../context/Auth";
import { Agrup, ButtonRotina, Icon, Organize, Seta, SubAgrup } from "../style";
import pg from "../../../assets/img/Pg.svg";
import seta from "../../../assets/img/seta.svg";
import { ButtonMenu } from "../ButtonMenu";
import { useLocation } from "react-router-dom";

export const MenuPG = (): ReactElement | null => {

  const { usuarioRotinas } = useContext<any>(AuthContext);

  const { pathname } = useLocation()

  const [pgclick, setClickpg] = useState<boolean>(false);

  const menus = usuarioRotinas.map((rotina: Rotina) => rotina.nomemenu);
  const rotinas = usuarioRotinas.map((rotina: Rotina) => rotina.nomerotina);

  return (
    <>
      {
        menus.some((menu: string) => menu == "PG") ?
          <ButtonRotina onClick={() => { setClickpg(!pgclick); }} >
            <Organize active={pathname?.match('pequenogrupo')}>
              <Agrup>
                <Icon src={pg} />
                <p>PG</p>
              </Agrup>
              <Seta active={pgclick} src={seta} />
            </Organize>

            {pgclick ?

              <SubAgrup onClick={(event) => event?.stopPropagation()}>
                {
                  rotinas.some((rotina: string) => rotina == "Dashboard Pg") ?
                    <ButtonMenu direcao="/dash/pequenogrupo/dashpg" nomeEstilo="subitem" titulo="Dashboard dos PGs" />
                    : false
                }
                {
                  rotinas.some((rotina: string) => rotina == "Conexão Pg") ?
                    <ButtonMenu direcao="/dash/pequenogrupo/conexoes" nomeEstilo="subitem" titulo="Conexões" />
                    : false
                }
                {
                  rotinas.some((rotina: string) => rotina == "Curso Lideres") ?
                    // </Link>
                    <ButtonMenu direcao="/dash/cursos/membros" nomeEstilo="subitem" titulo="Curso Líderes" />
                    : false
                }
                {
                  rotinas.some((rotina: string) => rotina == "Membros sem Pg") ?
                    <ButtonMenu direcao="/dash/pequenogrupo/membrossempg" nomeEstilo="subitem" titulo="Usuários sem PG" />
                    : false
                }
                {
                  rotinas.some((rotina: string) => rotina == "Lista de Membros") ?
                    <ButtonMenu direcao="/dash/pequenogrupo/membros" nomeEstilo="subitem" titulo="Lista de Participantes" />
                    : false
                }
                {
                  rotinas.some((rotina: string) => rotina == "Lista de Pg") ?
                    <ButtonMenu direcao="/dash/pequenogrupo/info" nomeEstilo="subitem" titulo="Lista de PGs" />
                    : false
                }
                {
                  rotinas.some((rotina: string) => rotina == "Cadastro Pg") ?
                    <ButtonMenu direcao="/dash/pequenogrupo/celula" nomeEstilo="subitem" titulo="Cadastro de PG" />
                    : false
                }
                {
                  rotinas.some((rotina: string) => rotina == "Evento Pg") ?
                    <ButtonMenu direcao="/dash/pequenogrupo/eventos" nomeEstilo="subitem" titulo="Criar Encontros/Turmas" />
                    : false
                }

              </SubAgrup>
              : false}

          </ButtonRotina>
          :
          false
      }
    </>
  )
}
